const ACTIVE_REQUEST_KEY_TTL_MS = 15 * 60 * 1000;
const activeRequestKeys = new Map();

function stableStringify(value) {
  if (Array.isArray(value)) {
    return `[${value.map((item) => stableStringify(item)).join(',')}]`;
  }

  if (value && typeof value === 'object') {
    return `{${Object.keys(value).sort().map((key) => `${JSON.stringify(key)}:${stableStringify(value[key])}`).join(',')}}`;
  }

  return JSON.stringify(value ?? null);
}

function hashString(value) {
  let hash = 5381;
  const input = String(value || '');
  for (let index = 0; index < input.length; index += 1) {
    hash = ((hash << 5) + hash) + input.charCodeAt(index);
    hash &= 0xffffffff;
  }
  return Math.abs(hash).toString(36);
}

function getFingerprint(scope, payload) {
  return `${scope}:${hashString(stableStringify(payload))}`;
}

function cleanupExpiredKeys() {
  const now = Date.now();
  Array.from(activeRequestKeys.entries()).forEach(([fingerprint, entry]) => {
    if (!entry?.createdAt || now - entry.createdAt > ACTIVE_REQUEST_KEY_TTL_MS) {
      activeRequestKeys.delete(fingerprint);
    }
  });
}

export function getIdempotencyKey(scope, payload = {}) {
  cleanupExpiredKeys();
  const fingerprint = getFingerprint(scope, payload);
  const existing = activeRequestKeys.get(fingerprint);
  if (existing?.key) {
    return existing.key;
  }

  const nextKey = `payrocky-${hashString(scope)}-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
  activeRequestKeys.set(fingerprint, {
    key: nextKey,
    createdAt: Date.now(),
  });
  return nextKey;
}

export function releaseIdempotencyKey(scope, payload = {}) {
  activeRequestKeys.delete(getFingerprint(scope, payload));
}

export function shouldRetainIdempotencyKey(error) {
  const message = String(error?.message || '').toLowerCase();
  return message.includes('unable to reach the server')
    || message.includes('check your internet connection')
    || message.includes('try again shortly')
    || message.includes('request timeout');
}
